import { render, staticRenderFns } from "./moreTG.vue?vue&type=template&id=010bdd82&lang=pug&"
import script from "./moreTG.vue?vue&type=script&lang=js&"
export * from "./moreTG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports